module.exports = __webpack_public_path__ + "LatoLatin-Light.54dc25dc196b054461c6.eot";


//////////////////
// WEBPACK FOOTER
// /Users/davidkross/Project/TaiwaneseTutor/front-end/TaiwaneseTutor/src/assets/fonts/LatoLatin/fonts/LatoLatin-Light.eot
// module id = ../../../../../src/assets/fonts/LatoLatin/fonts/LatoLatin-Light.eot
// module chunks = styles